// Buy more save more logic
const buyMoreSaveMore = () => {
    const container = document.querySelector('.product__buy-more-save-more');
    if (!container) return;

    const productEl = container.closest('.index-product');
    if (!productEl) return;

    const radios = container.querySelectorAll('[name="bmsm-quantity"]');
    const qtyInput = container.querySelector('[name="quantity"]');
    const priceEl = productEl.querySelector('[data-product-price-bmsm]');
    const oneTimeEl = productEl.querySelector('[data-rtx-onetime-price]');
    const subEl = productEl.querySelector('[data-rtx-subscription-price]');
    const mainPriceEl = productEl.querySelector('[data-price-wrapper] [data-product-price]');

    function getRtxBuyBox() {
        if (!window.retextionBuyBox) return null;
        const keys = Object.keys(window.retextionBuyBox);
        if (!keys.length) return null;
        return window.retextionBuyBox[keys[0]];
    }

    function getSubscriptionDiscount() {
        const buyBox = getRtxBuyBox();
        if (!buyBox) return null;

        const variantId = buyBox.variantId;
        const variant = buyBox.product.variants.find(v => v.id == variantId);
        const firstAllocation = variant?.selling_plan_allocations?.find(spa => {
            return buyBox.sellingPlanGroups.find(spg => spg.id == spa.selling_plan_group_id);
        });

        if (!firstAllocation || firstAllocation.price == variant.price) return null;

        const percentage = Math.round((1.0 - (firstAllocation.price / variant.price)) * 100);
        return percentage > 0 ? percentage / 100 : null;
    }

    function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function isOneTimeSelected() {
        const oneTimeRadio = productEl.querySelector('[id^="purchaseTypeOneTime"]');
        return !oneTimeRadio || oneTimeRadio.checked;
    }

    function updateRtxPrices(qty, basePrice, bmsmDiscount, subDiscount) {
        const originalTotal = basePrice * qty;
        const subTotal = Math.round(originalTotal * (1 - subDiscount));
        const finalTotal = subTotal - bmsmDiscount;

        if (oneTimeEl) {
            oneTimeEl.innerHTML = qty <= 1
                ? formatMoney(basePrice)
                : `${formatMoney(originalTotal - bmsmDiscount)} <s>${formatMoney(originalTotal)}</s>`;
        }

        if (subEl && subDiscount) {
            subEl.innerHTML = qty <= 1
                ? `${formatMoney(Math.round(basePrice * (1 - subDiscount)))} <s>${formatMoney(basePrice)}</s>`
                : `${formatMoney(finalTotal)} <s>${formatMoney(originalTotal)}</s>`;
        }
    }

    function updateMainPrice(qty, basePrice, bmsmDiscount, subDiscount) {
        if (!mainPriceEl) return;

        const originalTotal = basePrice * qty;
        const subTotal = Math.round(originalTotal * (1 - subDiscount));
        const finalTotal = subTotal - bmsmDiscount;

        if (isOneTimeSelected()) {
            mainPriceEl.innerHTML = qty <= 1
                ? formatMoney(basePrice)
                : `${formatMoney(originalTotal - bmsmDiscount)} <s>${formatMoney(originalTotal)}</s>`;
        } else {
            if (!subDiscount) {
                mainPriceEl.innerHTML = formatMoney(originalTotal - bmsmDiscount);
                return;
            }
            mainPriceEl.innerHTML = qty <= 1
                ? `${formatMoney(Math.round(basePrice * (1 - subDiscount)))} <s>${formatMoney(basePrice)}</s>`
                : `${formatMoney(finalTotal)} <s>${formatMoney(originalTotal)}</s>`;
        }
    }

    function updatePrice(qty) {
        if (!priceEl) return;

        const basePrice = parseInt(priceEl.dataset.basePrice);
        const savingsPerTier = parseInt(priceEl.dataset.savingsPerTier);

        if (!basePrice || !savingsPerTier) return;

        const tiers = [1, 2, 3, 4];
        const tierIndex = tiers.indexOf(qty);
        const bmsmDiscount = savingsPerTier * tierIndex * qty;
        const bmsmPricePerBar = basePrice - (savingsPerTier * tierIndex);
        const bmsmTotal = bmsmPricePerBar * qty;
        const subDiscount = getSubscriptionDiscount();

        updateRtxPrices(qty, basePrice, bmsmDiscount, subDiscount);
        updateMainPrice(qty, basePrice, bmsmDiscount, subDiscount);

        if (isOneTimeSelected()) {
            priceEl.innerHTML = qty <= 1
                ? formatMoney(basePrice)
                : `${formatMoney(bmsmTotal)} <s>${formatMoney(basePrice * qty)}</s>`;
        } else {
            if (!subDiscount) {
                priceEl.innerHTML = formatMoney(bmsmTotal);
                return;
            }
            const originalTotal = basePrice * qty;
            const subTotal = Math.round(originalTotal * (1 - subDiscount));
            const finalTotal = subTotal - bmsmDiscount;
            priceEl.innerHTML = qty <= 1
                ? `${formatMoney(Math.round(basePrice * (1 - subDiscount)))} <s>${formatMoney(basePrice)}</s>`
                : `${formatMoney(finalTotal)} <s>${formatMoney(originalTotal)}</s>`;
        }
    }

    function updateActiveRow(qty) {
        const labels = container.querySelectorAll('.pricing-savings__row');
        labels.forEach(label => {
            label.classList.toggle('bmsm-active', parseInt(label.querySelector('input[type="radio"]').value) === qty);
        });
    }

    function handleRadioChange(e) {
        const qty = parseInt(e.target.value);
        if (qtyInput) qtyInput.value = qty;
        updateActiveRow(qty);
        updatePrice(qty);
    }

    function resetQty() {
        radios.forEach(radio => {
            radio.checked = radio.value === '1';
        });
        if (qtyInput) qtyInput.value = 1;
        updateActiveRow(1);
        updatePrice(1);
    }

    radios.forEach(radio => {
        radio.addEventListener('change', handleRadioChange);
    });

    const purchaseTypeRadios = productEl.querySelectorAll('[id^="purchaseTypeOneTime"], [id^="purchaseTypeSubscription"]');
    purchaseTypeRadios.forEach(radio => {
        radio.addEventListener('change', resetQty);
    });
}

document.addEventListener("DOMContentLoaded", buyMoreSaveMore);
document.addEventListener('shopify:section:load', buyMoreSaveMore);